import * as React from "react";
import { createContext, Dispatch, FC, SetStateAction, useCallback, useContext, useMemo, useState } from "react";
import { IFilters } from "../Map/filters";
import { getMap } from "../Providers/mapProvider";
import { useNomaContext } from "./MapContext";

export interface IFiltersContext {
    filters: IFilters;
    setFilters: (newFilters: IFilters) => void;
    extent: number[];
    setExtent: () => void;
    resultsCount: number;
    setResultsCount: Dispatch<SetStateAction<number>>;
    setTabFilter: Dispatch<SetStateAction<number>>;
}

const FiltersContext = createContext<IFiltersContext>(null);

export const useFiltersContext = (): IFiltersContext => useContext(FiltersContext);

export const FiltersContextProvider: FC = (props: React.PropsWithChildren<IFiltersContext>) => {
    const { setActiveTab, filterDefaultValues } = useNomaContext();
    const [filters, setFilters] = useState<IFilters>(filterDefaultValues);
    const [extent, setExtent] = useState<number[]>([]);
    const [resultsCount, setResultsCount] = useState<number>(0);

    const updateExtent = useCallback(() => {
        const map = getMap();
        if (!map) {
            return;
        }
        const mapExtent = map.getView().calculateExtent(map.getSize());
        const isEqual = mapExtent.length === extent.length && mapExtent.every((val, i) => val === extent[i]);
        !isEqual && setExtent(mapExtent);
    }, [extent]);

    const values = useMemo(
        () => ({
            filters,
            setFilters,
            extent,
            setExtent: updateExtent,
            resultsCount,
            setResultsCount,
            setTabFilter: setActiveTab
        }),
        [filters, extent, resultsCount]
    );

    return <FiltersContext.Provider value={values}>{props.children}</FiltersContext.Provider>;
};
